// extracted by mini-css-extract-plugin
export default {"disposalQtyContainer":"styles_disposalQtyContainer__pgku7","title":"styles_title__Un6xg"};